<template>
  <div class="pt-3 px-3" v-if="!acessoBloqueado">
    <assina-termo />
    <psr :show="showPsr" @fechaPsrModal="showPsr = false" />
    <pse :show="showPse" @fechaPseModal="salvarTreino" />
    <div class="row">
      <div class="col-md-4 col-12">
        <div class="row">
          <div class="col-12">
            <calendar @selecionaDiaTreino="handleDateClick" />
          </div>
          <!-- Legenda do Calendário -->
          <div class="col-12 mt-2">
            <div class="card">
              <div class="card-body p-2">
                <div class="d-flex flex-wrap justify-content-around align-items-center" style="font-size: 0.8rem;">
                  <div class="d-flex align-items-center mb-1 me-2">
                    <span class="d-inline-block me-2" style="background-color: #28a745; width: 20px; height: 20px; border-radius: 3px;"></span>
                    <span class="font-weight-bold">Executado</span>
                  </div>
                  <div class="d-flex align-items-center mb-1 me-2">
                    <span class="d-inline-block me-2" style="background-color: #ffeb3b; width: 20px; height: 20px; border-radius: 3px;"></span>
                    <span class="font-weight-bold">Incompleto</span>
                  </div>
                  <div class="d-flex align-items-center mb-1 me-2">
                    <span class="d-inline-block me-2" style="background-color: #dc3545; width: 20px; height: 20px; border-radius: 3px;"></span>
                    <span class="font-weight-bold">Faltou</span>
                  </div>
                  <div class="d-flex align-items-center mb-1 me-2">
                    <span class="d-inline-block me-2" style="background-color: #ff9800; width: 20px; height: 20px; border-radius: 3px;"></span>
                    <span class="font-weight-bold">Férias</span>
                  </div>
                  <div class="d-flex align-items-center mb-1 me-2">
                    <span class="d-inline-block me-2" style="background-color: #2196f3; width: 20px; height: 20px; border-radius: 3px;"></span>
                    <span class="font-weight-bold">Excedente</span>
                  </div>
                  <div class="d-flex align-items-center mb-1">
                    <span class="d-inline-block me-2" style="background-color: #ffffff; width: 20px; height: 20px; border-radius: 3px; border: 3px solid #2196f3;"></span>
                    <span class="font-weight-bold">Hoje</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3" v-if="state.dataSelecionada && state.trainingResume != null">
            <h5 class="text-center mb-3">{{ $t('summary') }}</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="font-size: 0.85rem;">
                <thead class="table-light">
                  <tr>
                    <th class="text-center font-weight-bold" colspan="2" style="width: 50%; font-size: 0.9rem;">Resumo do Mês</th>
                    <th class="text-center font-weight-bold" colspan="2" style="width: 50%; font-size: 0.9rem;">Resumo do Plano</th>
                  </tr>
                </thead>
                <tbody style="font-size: 0.8rem;">
                  <tr>
                    <td style="width: 37.5%;">Treinos previstos no mês</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <template v-if="state.trainingResume.detalhes_mes && state.trainingResume.detalhes_mes.previstos !== undefined">
                        {{ state.trainingResume.detalhes_mes.previstos }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td style="width: 37.5%;">Treinos previstos no plano atual</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResume.total_trainings || 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 37.5%;">Aulas contratadas neste mês</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResume.aulas_contratadas_mes || '-' }}
                    </td>
                    <td style="width: 37.5%;">Aulas contratadas no plano atual</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResume.total_contratadas_plano || 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 37.5%;">Treinos executados</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <template v-if="state.trainingResume.detalhes_mes && state.trainingResume.detalhes_mes.executados !== undefined">
                        {{ state.trainingResume.detalhes_mes.executados }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td style="width: 37.5%;">Treinos executados</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResume.total_trainings_executed || 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 37.5%;">Treinos não executados</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <template v-if="state.trainingResume.detalhes_mes && state.trainingResume.detalhes_mes.nao_executados !== undefined">
                        {{ state.trainingResume.detalhes_mes.nao_executados }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td style="width: 37.5%;">Treinos não executados</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResume.total_trainings_not_executed || 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 37.5%;">Treinos incompletos</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <template v-if="state.trainingResume.detalhes_mes && state.trainingResume.detalhes_mes.incompletos !== undefined">
                        {{ state.trainingResume.detalhes_mes.incompletos }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td style="width: 37.5%;">Treinos incompletos</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResume.total_trainings_incomplete || 0 }}
                    </td>
                  </tr>
                  <tr class="table-warning">
                    <td style="width: 37.5%;">Treinos excedentes (mês atual)</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <span class="text-danger font-weight-bold">
                        <template v-if="state.trainingResume.detalhes_mes && state.trainingResume.detalhes_mes.excedentes !== undefined">
                          {{ state.trainingResume.detalhes_mes.excedentes }}
                        </template>
                        <template v-else>-</template>
                      </span>
                    </td>
                    <td style="width: 37.5%;">Treinos excedentes (plano atual)</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <span class="text-danger font-weight-bold">
                        {{ state.trainingResume.total_trainings_excedentes || 0 }}
                      </span>
                    </td>
                  </tr>
                  <tr style="background-color: #fff3e0;">
                    <td style="width: 37.5%;">Dias de férias (mês atual)</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <span style="color: #e65100;" class="font-weight-bold">
                        <template v-if="state.trainingResume.detalhes_mes && state.trainingResume.detalhes_mes.ferias !== undefined">
                          {{ state.trainingResume.detalhes_mes.ferias }}
                        </template>
                        <template v-else>-</template>
                      </span>
                    </td>
                    <td style="width: 37.5%;">Dias de férias (plano atual)</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      <span style="color: #e65100;" class="font-weight-bold">
                        {{ state.trainingResume.total_trainings_vacation || 0 }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="state.trainingResumeCaloric" class="table-info">
                    <td style="width: 37.5%;">Gasto calórico acumulado neste mês</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResumeCaloric.training_caloric || 0 }}
                    </td>
                    <td style="width: 37.5%;">Gasto calórico acumulado no plano atual</td>
                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                      {{ state.trainingResumeCaloric.plan_accumulated || 0 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group mt-3">
              <label for="">{{ $t('observations') }}: </label>
              <textarea
                rows="3"
                class="w-100 form-control"
                style="resize: none"
                v-model="state.observation"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12">
        <div class="row">
          <!-- CARD DE TREINAMENTO DE CARDIO -->
          <!-- <div class="col-12">
            <div class="card card-body">
              <div class="row">
                <div class="col-12 text-center">
                  <h5>{{ $t('cardioTraining') }}</h5>
                </div>
                <div class="col">
                  <label>{{ $t('modality') }}</label>
                  <select
                    class="form-control custom-select"
                    name="modalidades"
                    id="select-modalidades"
                    v-model="state.cardio.cardio_modality_id"
                  >
                    <option value="0">{{ $t('selectModality') }}</option>
                    <option
                      v-for="(modalidade, index) in state.modalidades"
                      :key="index"
                      :value="modalidade.id"
                    >
                      {{ modalidade.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label>{{ $t('method') }}</label>
                  <select
                    class="form-control custom-select"
                    name="grupos"
                    v-model="state.cardio.cardio_method_id"
                  >
                    <option value="0">{{ $t('selectMethod') }}</option>
                    <option
                      v-for="(modalidade, index) in state.metodos"
                      :key="index"
                      :value="modalidade.id"
                    >
                      {{ modalidade.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label class="required">{{ $t('time') }}</label>
                    <div class="input-group">
                      <input
                        placeholder="00:00"
                        type="text"
                        v-maska="'##:##'"
                        class="form-control"
                        v-model="state.cardio.cardio_time"
                      />
                      <span class="input-group-text" id="basic-addon2">{{ $t('minutes') }}</span>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label class="required">{{ $t('distance') }}</label>
                    <div class="input-group">
                      <money3
                        v-bind="state.config"
                        v-model="state.cardio.cardio_distance"
                        class="form-control"
                      ></money3>
                      <span class="input-group-text" id="basic-addon2">{{ $t('km') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- TABELA DE LISTA DE EXERCICIOS -->
          <div class="card card-body mt-4 mx-2" v-if="state.dataSelecionada">
            <div class="col-12">
              <div class="row">
                <div class="col-12 h5 mt-3 text-bold text-center">
                  {{ $t('trainingOfDay') }}
                  {{ state.dataSelecionada.split('-').reverse().join('/') }}
                </div>

                <div class="col-12 table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th scope="col" class="p-0">{{ $t('exercise') }}</th>
                        <th scope="col" class="p-0">{{ $t('loads') }}</th>
                        <th>{{ $t('status') }}</th>
                      </tr>
                    </thead>
                    <tbody class="text-sm" v-if="state.treinoElaborado.length === 0">
                      <tr>
                        <td
                          colspan="8"
                          class="font-weight-bold pt-3 text-decoration-underline text-center"
                        >
                          {{ $t('noExercises') }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody class="text-sm" v-else>
                      <tr
                        v-for="(element, index) in state.treinoElaborado"
                        :key="`${index}-${element.id || element.exercise_id}`"
                      >
                        <td class="align-middle" style="width: 20%">
                          {{ element.exercise.name }}
                          <!-- Indicador de tipo de exercício -->
                          <div v-if="element.cardio_modality_id" class="text-xs text-muted">
                            {{ $t('cardioExercise') }}
                          </div>
                        </td>
                        <td class="d-flex">
                          <!-- Exercícios de força (com series) -->
                          <template v-if="element.series && element.series.length > 0">
                            <table v-for="(load, loadIndex) in element.series" :key="loadIndex">
                              <tr>
                                <td
                                  rowspan="2"
                                  style="text-align: center; vertical-align: middle; height: 30px"
                                >
                                  <input
                                    class="form-control form-control-sm carga-input"
                                    type="text"
                                    v-model="load.load"
                                    v-maska="'###'"
                                    style="width: 60px; height: 65px; background-color: #e3f2fd; font-size: 1.3rem; font-weight: bold; color: #1565c0;"
                                  />
                                </td>
                                <td>
                                  <input
                                    class="form-control form-control-sm serie-input"
                                    type="text"
                                    v-model="load.series"
                                    v-maska="'###'"
                                    style="width: 60px; background-color: #fffde7; font-size: 1.1rem; font-weight: bold; color: #b28900;"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    class="form-control form-control-sm repeticao-input"
                                    type="text"
                                    v-model="load.repetitions"
                                    v-maska="'###'"
                                    style="width: 60px; background-color: #e8f5e9; font-size: 1.1rem; font-weight: bold; color: #388e3c;"
                                  />
                                </td>
                              </tr>
                            </table>
                          </template>

                          <!-- Exercícios de cardio (com cardio_details) -->
                          <div
                            v-if="element.cardio_details && element.cardio_details.length > 0"
                            class="w-100"
                            :key="`cardio-${element.id || element.exercise_id}`"
                          >
                            <!-- Tabela para método contínuo -->
                            <table
                              v-if="getCardioMethodType(element) === 'continuo'"
                              class="table table-sm table-bordered"
                            >
                              <thead>
                                <tr>
                                  <th class="text-center">{{ $t('stage') }}</th>
                                  <th class="text-center">{{ $t('time') }}</th>
                                  <th class="text-center">{{ $t('distance') }}</th>
                                  <th class="text-center">{{ $t('pace') }}</th>
                                  <th class="text-center">{{ $t('vo2PerTime') }}</th>
                                  <th class="text-center">{{ $t('fctr') }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(detail, detailIndex) in element.cardio_details"
                                  :key="detailIndex"
                                >
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.stage"
                                      min="1"
                                      style="width: 60px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="text"
                                      v-model="detail.time"
                                      v-maska="'##:##:##'"
                                      placeholder="00:00:00"
                                      style="width: 100px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.distance"
                                      style="width: 80px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.pace"
                                      step="0.01"
                                      style="width: 80px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.vo2_per_time"
                                      step="0.01"
                                      style="width: 80px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.fctr"
                                      style="width: 60px"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!-- Tabela para método intervalado -->
                            <table
                              v-if="getCardioMethodType(element) === 'intervalado'"
                              class="table table-sm table-bordered"
                            >
                              <thead>
                                <tr>
                                  <th class="text-center">{{ $t('stage') }}</th>
                                  <th class="text-center">{{ $t('time') }}</th>
                                  <th class="text-center">{{ $t('distance') }}</th>
                                  <th class="text-center">{{ $t('recoveryTime') }}</th>
                                  <th class="text-center">{{ $t('load') }}</th>
                                  <th class="text-center">{{ $t('fca') }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(detail, detailIndex) in element.cardio_details"
                                  :key="detailIndex"
                                >
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.stage"
                                      min="1"
                                      style="width: 60px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="text"
                                      v-model="detail.time"
                                      v-maska="'##:##'"
                                      placeholder="00:00"
                                      style="width: 100px"
                                      @input="formatTime($event, detail, 'time')"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.distance"
                                      style="width: 80px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="text"
                                      v-model="detail.recovery_time"
                                      v-maska="'##:##'"
                                      placeholder="00:00"
                                      style="width: 80px"
                                      @input="formatTime($event, detail, 'recovery_time')"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.load"
                                      style="width: 60px"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <input
                                      class="form-control form-control-sm text-center"
                                      type="number"
                                      v-model="detail.fca"
                                      style="width: 60px"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                        <td>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              v-model="element.realized"
                              value="1"
                              @change="verificaTodosRealizados()"
                            />
                            <label class="form-check-label" for="flexSwitchCheckDefault">{{
                              element.realized ? $t('done') : $t('notDone')
                            }}</label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="3">
                          <div class="float-end">
                            <div class="form-check form-switch" @click="marcarTodos">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="flexSwitchCheckDefault"
                                :checked="state.todosMarcados"
                              />
                              <label class="form-check-label" for="flexSwitchCheckDefault">{{
                                state.todosMarcados ? $t('allDone') : $t('allNotDone')
                              }}</label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 text-end" v-if="state.dataSelecionada">
              <div class="d-flex form-group justify-content-xl-end text-end">
                <label class="align-self-end me-2">{{ $t('trainingTime') }}</label>
                <div class="input-group w-25">
                  <input
                    placeholder="00:00"
                    type="text"
                    v-maska="'##:##'"
                    class="form-control"
                    v-model="state.cardio.training_time"
                  />
                  <span class="input-group-text" id="basic-addon2">{{ $t('minutes') }}</span>
                </div>
              </div>
              <button type="button" class="ms-3 btn bg-gradient-primary" @click="showPse = true">
                {{ $t('save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n' // Importe o useI18n
import calendar from './calendar.vue'
import psr from './psrModal.vue'
import pse from './pseModal.vue'
//import draggable from "vuedraggable";
import kpiRepository from '../../../../services/api/kpiRepository'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import modalidadeRepository from '@/services/api/modalidadeRepository'
import metodoRepository from '@/services/api/metodoRepository'
import alunoRepository from '@/services/api/alunoRepository'
import { Money3Component } from 'v-money3'
import AssinaTermo from '@/views/pages/treinador/areaAluno/assinaTermo.vue'

export default {
  components: {
    AssinaTermo,
    //draggable,
    calendar,
    psr,
    pse,
    money3: Money3Component,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()
    const { t } = useI18n() // Use o useI18n para obter o t

    onMounted(async () => {
      /*if(route.params.id && parseInt(route.params.id) > 0) {
        state.composicaoId = parseInt(route.params.id)
      }
      buscarDadosComposicao()*/
      store.commit('SET_SPLASH_SCREEN', false)
      buscarModalidade()
      buscarMetodos()
      verificaBloqueio()
      let psrNota = window.localStorage.getItem('psr')
      console.log(psrNota)
      if (store.getters.UserType == 's' && psrNota == null) {
        showPsr.value = true
      }

      // Se veio da agenda com uma data específica, selecionar automaticamente
      if (route.query.date) {
        await nextTick()
        handleDateClick(route.query.date)
      }
    })

    // Watch para forçar reatividade quando os dados mudarem
    // Mover para depois da inicialização do state

    // let modalidadeSelecionadaId = ref('0')
    let showPsr = ref(false)
    let showPse = ref(false)
    let acessoBloqueado = ref(false)

    const state = reactive({
      todosMarcados: false,
      trainingResumeCaloric: null,
      trainingResume: null,
      dataSelecionada: null,
      treinoElaborado: [],
      exerciciosTestados: [],
      metodos: [],
      modalidades: [],
      observation: '',
      cardio: {
        training_time: null,
        cardio_time: null,
        cardio_distance: '',
        cardio_method_id: 0,
        cardio_modality_id: 0,
      },
      config: {
        masked: false,
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 3,
        disableNegative: false,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
      },
    })

    // Remover watch que estava causando problemas

    // Função para formatar tempo
    function formatTime(event, detail, field) {
      let value = event.target.value

      // Se o valor tem 3 partes (HH:MM:SS), converter para MM:SS
      if (value.includes(':') && value.split(':').length === 3) {
        const parts = value.split(':')
        value = `${parts[1]}:${parts[2]}`
        detail[field] = value
      }
    }

    async function handleDateClick(date = null) {
      state.dataSelecionada = date
      if (date == null) return

      store.commit('SET_SPLASH_SCREEN', true)

      try {
        // Garantir que os métodos estejam carregados antes de processar os dados
        if (!state.metodos || state.metodos.length === 0) {
          await new Promise((resolve, reject) => {
            metodoRepository
              .MetodoGet()
              .then((response) => {
                if (response.data.success) {
                  state.metodos = response.data.data
                  resolve()
                } else {
                  reject(new Error('Falha ao carregar métodos'))
                }
              })
              .catch(reject)
          })
        }

        const response = await planosTreinoRepository.TreinoPorDiaGet(date)

        if (response.data.success) {
          console.log('Dados recebidos da API:', response.data.data)

          // Limpar array primeiro
          state.treinoElaborado.length = 0

          // Processar e adicionar dados um por um para forçar reatividade
          response.data.data.forEach((item) => {
            const processedItem = { ...item }
            processedItem['realized'] = parseInt(item['realized']) == 1

            // Garantir que cardio_details seja processado corretamente
            if (processedItem.cardio_details && processedItem.cardio_details.length > 0) {
              processedItem.cardio_details = processedItem.cardio_details.map((detail) => {
                const processedDetail = { ...detail }

                // Garantir que os campos de tempo estejam no formato correto
                if (processedDetail.time && typeof processedDetail.time === 'string') {
                  // Converter de "00:00:45" para "00:45" se necessário
                  if (
                    processedDetail.time.includes(':') &&
                    processedDetail.time.split(':').length === 3
                  ) {
                    const timeParts = processedDetail.time.split(':')
                    processedDetail.time = `${timeParts[1]}:${timeParts[2]}`
                  }
                }

                if (
                  processedDetail.recovery_time &&
                  typeof processedDetail.recovery_time === 'string'
                ) {
                  // Converter de "00:01:30" para "01:30" se necessário
                  if (
                    processedDetail.recovery_time.includes(':') &&
                    processedDetail.recovery_time.split(':').length === 3
                  ) {
                    const timeParts = processedDetail.recovery_time.split(':')
                    processedDetail.recovery_time = `${timeParts[1]}:${timeParts[2]}`
                  }
                }

                // Garantir que números sejam números
                if (processedDetail.stage)
                  processedDetail.stage = parseInt(processedDetail.stage) || 0
                if (processedDetail.distance)
                  processedDetail.distance = parseInt(processedDetail.distance) || 0
                if (processedDetail.load) processedDetail.load = parseInt(processedDetail.load) || 0
                if (processedDetail.fca) processedDetail.fca = parseInt(processedDetail.fca) || 0

                return processedDetail
              })
            }

            state.treinoElaborado.push(processedItem)
          })

          console.log('Dados processados com formatação:', state.treinoElaborado)

          console.log('Dados no state após atribuição:', state.treinoElaborado)

          // verifica se tem algum exercicio e se tem informacao de cardio
          if (state.treinoElaborado.length > 0) {
            let item = state.treinoElaborado[0]

            if (state.treinoElaborado[0]['cardio_modality_id'] != null) {
              state.cardio.cardio_distance = item.cardio_distance
              state.cardio.cardio_modality_id = item.cardio_modality_id
              state.cardio.cardio_time = item.cardio_time
              state.cardio.cardio_method_id = item.cardio_method_id
            }
            state.cardio.training_time = item.training_time
            state.observation = item.observation
            verificaTodosRealizados()
          }

          // Forçar reatividade final
          if (state.treinoElaborado.length > 0) {
            console.log('Forçando reatividade final...')
            // Trigger reatividade
            state.treinoElaborado = [...state.treinoElaborado]
          }
        }

        // Aguardar o próximo tick para garantir que a reatividade funcione
        await nextTick()
      } catch (error) {
        console.error(error.message)
        swal({
          icon: 'error',
          title: t('errorFetchingTraining'),
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
        buscarResumo()
        buscarGastoCalorico()
      }
    }

    function verificaTodosRealizados() {
      let allTrue = true
      state.treinoElaborado.forEach((item) => {
        console.log(item['realized'])
        if (!item['realized']) {
          allTrue = false
        }
      })
      state.todosMarcados = allTrue
    }

    const buscarGastoCalorico = () => {
      if (!state.dataSelecionada) return

      store.commit('SET_SPLASH_SCREEN', true)

      // Extrair ano e mês da data selecionada para buscar o gasto calórico do mês
      const [year, month] = state.dataSelecionada.split('-')

      kpiRepository
        .CaloricExpenditureByMonthGet(year, month)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.trainingResumeCaloric = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorFetchingCaloricExpenditure'),
            text: error.message,
          })
        })
        .finally(() => {
          store.commit('SET_SPLASH_SCREEN', false)
        })
    }

    const buscarResumo = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      kpiRepository
        .TrainingResumeGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            let resumo = response.data.data

            // Adicionar detalhes do mês SELECIONADO (não o mês atual)
            if (resumo && resumo.detalhes_por_mes && state.dataSelecionada) {
              // Extrair ano e mês da data selecionada (formato: YYYY-MM-DD)
              const dateParts = state.dataSelecionada.split('-')
              const year = dateParts[0]
              const month = dateParts[1]
              const key = `${year}-${month}`
              const detalhes = resumo.detalhes_por_mes[key]

              state.trainingResume = {
                ...resumo,
                detalhes_mes: detalhes || null
              }
            } else {
              state.trainingResume = resumo
            }
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorFetchingSummary'),
            text: error.message,
          })
        })
        .finally(() => {
          store.commit('SET_SPLASH_SCREEN', false)
        })
    }

    const buscarModalidade = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      modalidadeRepository
        .ModalidadeGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.modalidades = response.data.data
            /*if(props.modalidadeId > 0) {
            modalidadeSelecionadaId.value = props.modalidadeId
            buscarGrupoPorModalidade()
          }*/
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorFetchingModality'),
            text: error.message,
          })
        })
    }

    // Função para determinar se um exercício de cardio é intervalado ou contínuo
    function getCardioMethodType(element) {
      if (
        !element ||
        (!element.is_cardio && !element.cardio_method_id && !element.cardio_modality_id)
      )
        return null

      // Se não há métodos carregados ainda, tentar inferir pelo cardio_details
      if (!state.metodos || state.metodos.length === 0) {
        if (element.cardio_details && element.cardio_details.length > 0) {
          const firstDetail = element.cardio_details[0]
          // Se tem recovery_time, provavelmente é intervalado
          if (firstDetail.recovery_time && firstDetail.recovery_time !== '00:00:00') {
            return 'intervalado'
          } else {
            return 'continuo'
          }
        }
        return null
      }

      const metodo = state.metodos.find((m) => m.id === element.cardio_method_id)
      if (!metodo) return null

      const methodName = metodo.name.toLowerCase()

      if (methodName.includes('intervalado')) {
        return 'intervalado'
      } else if (methodName.includes('contínuo') || methodName.includes('continuo')) {
        return 'continuo'
      }

      return null
    }

    const buscarMetodos = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      //selecionaModalidade()
      metodoRepository
        .MetodoGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.metodos = response.data.data
            /*if(props.grupoId > 0) {
            grupoSelecionadoId.value = props.grupoId
          }*/
            //buscarGrupo(state.exercicio.group_id)
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorFetchingMethods'),
            text: error.message,
          })
        })
    }

    const atualizarExercicio = async (index, elementId, elementRealized) => {
      store.commit('SET_SPLASH_SCREEN', true)
      state.treinoElaborado[index].realized = !state.treinoElaborado[index].realized
      //selecionaModalidade()
      let data = {
        realized: state.treinoElaborado[index].realized,
      }

      try {
        const response = await planosTreinoRepository.PlanoTreinoAtualizarExerciciosPorId(elementId, data)

        if (response.data.success) {
          // Calcular o novo status baseado nos exercícios
          const totalExercises = state.treinoElaborado.length
          const executedExercises = state.treinoElaborado.filter(item => item.realized).length

          let newStatus = 'not_executed'
          if (executedExercises === totalExercises && totalExercises > 0) {
            newStatus = 'executed'
          } else if (executedExercises > 0) {
            newStatus = 'incomplete'
          }

          console.log(`[AreaAluno] Status calculado: ${newStatus} (${executedExercises}/${totalExercises} executados)`)

          // Atualizar o status na tabela training_schedule_status
          if (state.dataSelecionada) {
            try {
              await planosTreinoRepository.DiasDeTreinoStatusPut(state.dataSelecionada, newStatus)
              console.log(`[AreaAluno] Status "${newStatus}" salvo para data ${state.dataSelecionada}`)
            } catch (statusError) {
              console.warn('[AreaAluno] Erro ao salvar status:', statusError)
            }
          }

          swal({
            icon: 'success',
            text: t('realizationRegisteredSuccessfully'),
          })
        } else {
          swal({
            icon: 'error',
            text: t('unableToRegisterExecution'),
          })
          // se der errado reverte o estado de realização do exercicio
          state.treinoElaborado[index].realized = !state.treinoElaborado[index].realized
        }
      } catch (error) {
        // se der errado reverte o estado de realização do exercicio
        state.treinoElaborado[index].realized = !state.treinoElaborado[index].realized
        swal({
          icon: 'error',
          text: t('unableToRegisterExecution'),
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const salvarTreino = async () => {
      let data = []
      let psr = window.localStorage.getItem('psr')
      let pse = window.localStorage.getItem('pse')
      state.treinoElaborado.forEach((obj) => {
        // ✅ Criar cópia plana do objeto (sem Vue reactivity)
        let item = JSON.parse(JSON.stringify(obj))
        item['observation'] = state.observation
        item['cardio_time'] = state.cardio.cardio_time
        item['cardio_distance'] = state.cardio.cardio_distance
        item['psr'] = psr
        item['training_time'] = state.cardio.training_time
        item['pse'] = pse
        item['cardio_method_id'] =
          parseInt(state.cardio.cardio_method_id) > 0
            ? parseInt(state.cardio.cardio_method_id)
            : null
        item['cardio_modality_id'] =
          parseInt(state.cardio.cardio_modality_id) > 0
            ? parseInt(state.cardio.cardio_modality_id)
            : null
        data.push(item)
      })
      console.log('✅ Dados da área do aluno a serem enviados:', JSON.stringify(data, null, 2))
      // return
      showPse.value = false
      store.commit('SET_SPLASH_SCREEN', true)

      try {
        // Salvar exercícios
        const response = await planosTreinoRepository.PlanoTreinoAtualizarExerciciosDiaPost(data)

        if (response.data.success) {
          // Calcular o status baseado nos exercícios marcados
          const totalExercises = state.treinoElaborado.length
          const executedExercises = state.treinoElaborado.filter(item => item.realized).length

          let newStatus = 'not_executed'
          if (executedExercises === totalExercises && totalExercises > 0) {
            newStatus = 'executed'
          } else if (executedExercises > 0) {
            newStatus = 'incomplete'
          }

          console.log(`[AreaAluno] Status calculado: ${newStatus} (${executedExercises}/${totalExercises} executados)`)

          // Atualizar o status na tabela training_schedule_status
          if (state.dataSelecionada) {
            try {
              await planosTreinoRepository.DiasDeTreinoStatusPut(state.dataSelecionada, newStatus)
              console.log(`[AreaAluno] Status "${newStatus}" salvo para data ${state.dataSelecionada}`)
            } catch (statusError) {
              console.warn('[AreaAluno] Erro ao salvar status (exercícios foram salvos):', statusError)
            }
          }

          swal({
            icon: 'success',
            text: t('trainingSavedSuccessfully'),
          })
        }
      } catch (error) {
        swal({
          icon: 'error',
          title: t('errorSavingTraining'),
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    function marcarTodos() {
      state.todosMarcados = !state.todosMarcados
      console.log(state.todosMarcados)
      if (state.todosMarcados) {
        state.treinoElaborado.forEach((item) => {
          item.realized = true
        })
      } else {
        state.treinoElaborado.forEach((item) => {
          item.realized = false
        })
      }
    }

    function verificaBloqueio() {
      alunoRepository.AlunoBloqueadoGet().then((response) => {
        if (response.data.success) {
          const data = response.data.data

          acessoBloqueado.value = data.block
          console.log('acessoBloqueado')
          console.log(data)
          if (acessoBloqueado.value) {
            swal({
              icon: 'error',
              text: t('accessBlockedContactYourTrainer'),
            })
          } else {
            if (data.remaingDays < 0 && data.remaingDays >= -3) {
              swal({
                icon: 'info',
                text: t('paymentNotIdentifiedRememberToKeepYourPaymentUpToDate'),
              })
            }
            if (data.remaingDays >= 0 && data.remaingDays <= 3) {
              swal({
                icon: 'info',
                text: t('paymentDateIsNearRememberToKeepYourPaymentUpToDate'),
              })
            }
            if (data.remaingDays < -3) {
              swal({
                icon: 'info',
                text: t('paymentNotIdentifiedContactYourTrainer'),
              })
            }
          }
        }
      })
    }

    return {
      state,
      marcarTodos,
      handleDateClick,
      // modalidadeSelecionadaId,
      // metodoSelecionadoId,
      salvarTreino,
      atualizarExercicio,
      showPsr,
      showPse,
      acessoBloqueado,
      verificaTodosRealizados,
      getCardioMethodType,
      formatTime,
      t,
    }
  },
}
</script>

<style scoped>
.table-responsive {
  max-height: 400px;
}

.form-control-sm {
  min-width: 60px !important;
  font-size: 12px !important;
}

.table-sm td,
.table-sm th {
  padding: 0.25rem !important;
  vertical-align: middle !important;
}

/* Garantir que os campos de input sejam visíveis */
input[type='text'],
input[type='number'] {
  min-width: 60px !important;
  max-width: 100px !important;
}

/* Cores mais neutras e agradáveis para as caixas */
.carga-input {
  background-color: #f5f5f5 !important; /* cinza claro */
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #333 !important;
  text-align: center !important;
  border: 1px solid #e0e0e0 !important;
}

.serie-input {
  background-color: #e3ecfa !important; /* azul bem claro */
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2a4d7a !important;
  text-align: center !important;
  border: 1px solid #b3c6e0 !important;
}

.repeticao-input {
  background-color: #e7f6ef !important; /* verde claro suave */
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2e5d47 !important;
  text-align: center !important;
  border: 1px solid #b2dfdb !important;
}
</style>
